module.exports = __webpack_public_path__ + "img/03a_Store_651.98011236.jpg";